module.exports = __webpack_public_path__ + "static/media/Correct-icon.4eeaec47.svg";